import { createSelector } from 'reselect';
import { Highlights } from '@fullstory/client-api';
import { AppState } from '../../types';

const getHighlightsData = (state: AppState): Highlights => state.highlights.highlights.data;
export const getActiveIntegrations = createSelector(
  getHighlightsData,
  data => data.ActiveIntegrations,
);
export const getHighlights = createSelector(getHighlightsData, data => data.Highlights);

export const getHighlight = createSelector(
  getHighlights,
  highlights => (highlightId: string) =>
    highlights?.find(highlight => highlight?.Id === highlightId),
);
